<template>
  <div class="search-wrapper">
    <p class="title"><strong>Pesquisa</strong></p>
    <form ref="formFilter">
      <div class="w-full input-group">
        <select-input class="input" label="Promotor" :items="selectArray" />
        <select-input class="input" label="Rede" :items="selectArray" />
        <select-input class="input" label="Mercado" :items="selectArray" />
        <select-input class="input" label="Fornecedor" :items="selectArray" />
        <select-input class="input" label="Marca" :items="selectArray" />
        <select-input class="input" label="Produto" :items="selectArray" />
        <select-input class="input" label="Cidade" :items="selectArray" />
        <select-input class="input" label="Estado" :items="selectArray" />
        <select-input class="input" label="Status" :items="selectArray" />
      </div>
      <div class="btn-group">
        <button class="btn btn-purple">
          <font-awesome-icon icon="fa-magnifying-glass" class="text-white mr-0 lg:mr-2" />
          Pesquisar
        </button>
        <button class="btn btn-purple-outline">
          <font-awesome-icon icon="fa-eraser" class="mr-0 lg:mr-2" />
          Limpar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import SelectInput from '@/Shared/SelectInput'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
  components: {
    SelectInput,
  },

  data() {
    return {
      selectArray: [
        {
          label: 'Promotor',
          value: 'promotor',
          id: 1,
        },
        {
          label: 'Rede',
          value: 'rede',
          id: 2,
        },
        {
          label: 'Mercado',
          value: 'mercado',
          id: 3,
        },
        {
          label: 'Fornecedor',
          value: 'fornecedor',
          id: 4,
        },
        {
          label: 'Marca',
          value: 'marca',
          id: 5,
        },
        {
          label: 'Produto',
          value: 'produto',
          id: 6,
        },
        {
          label: 'Cidade',
          value: 'cidade',
          id: 7,
        },
        {
          label: 'Estado',
          value: 'estado',
          id: 8,
        },
        {
          label: 'Status',
          value: 'status',
          id: 9
        },
      ],
      form: useForm({
        promotor: '',
        rede: '',
        mercado: '',
        fornecedor: '',
        marca: '',
        produto: '',
        cidade: '',
        estado: '',
        status: '',
      }),
    }
  }
}
</script>

<style scoped>
.search-wrapper {
  background: #F9F9F9;
  border-radius: 6px;
  padding: 2.5rem 0;
}

.search-wrapper .title {
  padding: 0 1rem;
  font-family: "Poppins";
  font-size: 1.13rem;
}

.input-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.input {
  width: 25%;
  padding: 0 1rem;
}

.btn-purple-outline {
  color: #383874;
  border: 1px solid #383874;
}

.btn-purple-outline:is(:hover, :focus) {
  filter: brightness(2);
}

.btn {
  border-radius: 6px;
  font-family: "Poppins";
  font-weight: normal;
  padding: .8125rem;
}

.btn-group {
  padding: 1.5rem 1rem 0;
  gap: 1rem;
  display: flex;
}
</style>